import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { data } from 'jquery';
import { observable, Observable } from 'rxjs';
import { NewVulnerabilityService } from './new-vulnerability.service';
import { newVulClass } from './newVulClass';
import { VulClass } from './VulClass';

@Injectable({
  providedIn: 'root'
})
export class DataResolverService  {

  constructor(private vulService : NewVulnerabilityService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): 
  Observable<newVulClass[]> {
    console.log("resolver called");
     
    return this.vulService.getGridData();
  //return "data";
  };
  
}
